import isEmpty from "lodash/isEmpty"
import { arabicToInt } from "../utilities/arabicNumParser"

export default function validateInput(data) {
  let errors = {}
  const lang_code = localStorage.getItem("lang")

  const lang_required = {
    fr: {
      message_required: `Ce champ est requis`,
    },
    en: {
      message_required: `This field is required`,
    },
    sw: {
      message_required: `Ni lazima kujaza nafasi hii`,
    },
    ZARMA: {
      message_required: `Tilas batamo hima ga bara`,
    },
    HAOUSSA: {
      message_required: `Doole hilin ga shina nan`,
    },
    es: {
      message_required: `Este campo es requerido`,
    },
    ar: {
      message_required: `هذا الحقل اجباري`,
    },
    pt: {
      message_required: `Este campo é obrigatório`,
    },
  }

  const lang_digits_only = {
    fr: {
      message_required: `Entrez uniquement des chiffres`,
    },
    en: {
      message_required: `Enter digits only`,
    },
    sw: {
      message_required: `Ingiza tarakimu pekee`,
    },
    ZARMA: {
      message_required: `Hantum  lambayze hinne`,
    },
    HAOUSSA: {
      message_required: `Rubuta ỳan ƙilgo kaɗay`,
    },
    es: {
      message_required: `Inserta solo dígitos`,
    },
    ar: {
      message_required: `ادخال أرقام فقط`,
    },
    pt: {
      message_required: `Insira apenas dígitos`,
    },
  }

  const lang_length = {
    fr: {
      message_required: `Le nombre d'actions doit être compris entre 1 et 99`,
    },
    en: {
      message_required: `Shares number should be between 1 and 99`,
    },
    sw: {
      message_required: `Idadi ya hisa ni kati ya 1 hadi 99`,
    },
    ZARMA: {
      message_required: `Zarma for Shares number should be between 1 and 99`,
    },
    HAOUSSA: {
      message_required: `Hannayen jari  daga 1 zuwa 99`,
    },
    es: {
      message_required: `El número de acciones debe ser entre 1 y 99`,
    },
    pt: {
      message_required: `O número de ações deve estar entre 1 e 99`,
    },
  }

  if (data.amount === "") {
    errors.amount = lang_required[lang_code].message_required
  }
  if (isNaN(arabicToInt(data.amount))) {
    errors.amount = lang_digits_only[lang_code].message_required
  }

  if (data.amount < 0 || data.amount > 99999999) {
    errors.amount = lang_length[lang_code].message_required
  }

  return {
    errors,
    isValid: isEmpty(errors),
  }
}
